import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { CoreLevel } from '@wix/da-react-context/pkg/publicSession';
import {
  DOLLAR_PRICE_MIN_VALUE,
  getMaxPriceForCoreLevel,
} from '@wix/da-shared-react/pkg/utils/profits';
import { formatDollars } from '@wix/da-shared-react/pkg/utils/formatting';
import { PremiumFolderType } from '@wix/da-shared-react/pkg/types/gallection';

const MAX_TITLE_LENGTH = 50;

export const useValidation = (coreLevel: CoreLevel) => {
  const { t } = useTranslation();
  const maxPrice = getMaxPriceForCoreLevel(coreLevel);
  const validationSchema = yup.object({
    name: yup
      .string()
      .max(MAX_TITLE_LENGTH, t('studio.modals.folder.errors.name.tooLong'))
      .matches(/^[a-zA-Z0-9 _$?:.,'"+-]*$/, {
        message: t('studio.modals.folder.errors.name.format'),
      })
      .required(t('studio.modals.folder.errors.name.required')),
    folderType: yup.string(),
    price: yup.number().when('folderType', {
      is: `${PremiumFolderType.Paid}`,
      // eslint-disable-next-line unicorn/no-thenable
      then: yup
        .number()
        .required(t('common.dollarPriceInput.validation.error.missingValue'))
        .typeError(t('common.dollarPriceInput.validation.error.invalidValue'))
        .min(
          DOLLAR_PRICE_MIN_VALUE,
          t('common.dollarPriceInput.validation.error.minValue', {
            min: formatDollars(DOLLAR_PRICE_MIN_VALUE),
          })
        )
        .max(
          maxPrice,
          t('common.dollarPriceInput.validation.error.maxValue', {
            max: formatDollars(maxPrice),
          })
        ),
      otherwise: yup.number().nullable(),
    }),
  });
  return validationSchema;
};
